import React, { useEffect, useState } from "react";
import "./dhealnavbar.css";

import { FiMoon } from "react-icons/fi";
import { FaSearch } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import i18n from "../i18n/i18n";
import { useNavigate } from "react-router-dom";
import biharLogo from "../assest/bihar-logo.png";

const Dhealnavbar = ({ toggleTheme }) => {

  const { t } = useTranslation();
  const navigate = useNavigate();
  const [langMenu, setLangMenu] = useState(false);
 const [selectedLang, setSelectedLang] = useState("English");


  const handleLanguageToggle = () => {
    setLangMenu(!langMenu);
  };

const handleLanguageChange = (lng) => {
  i18n.changeLanguage(lng);
  localStorage.setItem("i18nextLng", lng);

  if (lng === "en") setSelectedLang("English");
  else if (lng === "hi") setSelectedLang("हिंदी");

  setLangMenu(false);

  // Dispatch language changed event to notify widget
  const event = new CustomEvent("languageChanged", {
    detail: lng
  });
  window.dispatchEvent(event);
};

  const changeFontSize = (action) => {
    let current = parseInt(localStorage.getItem("fontSize") || 100);

    if (action === "increase") current = Math.min(current + 10, 150);
    if (action === "decrease") current = Math.max(current - 10, 70);
    if (action === "reset") current = 100;

    document.documentElement.style.fontSize = current + "%";
    localStorage.setItem("fontSize", current);
  };
useEffect(() => {
  const savedLang = localStorage.getItem("i18nextLng") || "en";

  i18n.changeLanguage(savedLang);

  if (savedLang === "en") setSelectedLang("English");
  else if (savedLang === "hi") setSelectedLang("हिंदी");

  const savedFont = localStorage.getItem("fontSize") || 100;
  document.documentElement.style.fontSize = savedFont + "%";
}, []);

const navLinks = [
  { label: t("home"), action: () => navigate("/") },
  { label: t("about"), action: () => {
    const currentPath = window.location.pathname;
    if (currentPath === "/") {
      // Already on home, scroll to about section
      const aboutSection = document.getElementById("bihar-about-section");
      if (aboutSection) {
        aboutSection.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      // Not on home, navigate to home
      navigate("/");
      // Scroll after navigation completes
      setTimeout(() => {
        const aboutSection = document.getElementById("bihar-about-section");
        if (aboutSection) {
          aboutSection.scrollIntoView({ behavior: "smooth" });
        }
      }, 500);
    }
  }},
  { label: t("samadhan"), action: () => window.open("https://dashboard-aigram.texoriai.com/", "_blank") },
];

  return (
    <>
      <header className="dhealnavbar-header-sticky">

        {/* TOP BLUE NAVBAR */}
        <div className="DhenkanalNavbarPage-topbar">
          <div className="DhenkanalNavbarPage-topbar-left">
            <img src={biharLogo} alt="Bihar Logo" className="DhenkanalNavbarPage-topbar-logo" />
            <span className="DhenkanalNavbarPage-govt">
              <span>{t("govt")}</span>
              <span>{t("govtSub")}</span>
            </span>
          </div>

          <nav className="DhenkanalNavbarPage-top-links" aria-label="Main navigation">
            {navLinks.map((link) => (
              <button
                key={link.label}
                type="button"
                className="DhenkanalNavbarPage-top-link"
                onClick={link.action}
              >
                {link.label}
              </button>
            ))}
          </nav>

          <div className="DhenkanalNavbarPage-top-right">

            {/* Search Box */}
            <div className="DhenkanalNavbarPage-searchbox">
              <input type="text" placeholder={t("search")} />
              <button className="DhenkanalNavbarPage-search-btn">
                <FaSearch />
              </button>
            </div>

            {/* Icons */}
            <div className="DhenkanalNavbarPage-icons">
              <span onClick={toggleTheme} className="theme-icon-circle">
                <FiMoon size={14} />
              </span>

              {/* UPDATED TO BUTTONS */}
              <button className="DhenkanalNavbarPage-fonticon" onClick={() => changeFontSize("decrease")}>A-</button>
              <button className="DhenkanalNavbarPage-fonticon" onClick={() => changeFontSize("reset")}>A</button>
              <button className="DhenkanalNavbarPage-fonticon" onClick={() => changeFontSize("increase")}>A+</button>

            </div>

            {/* Language Dropdown */}
            <div
              className="DhenkanalNavbarPage-lang-select"
              onClick={handleLanguageToggle}
            >
              {selectedLang}
              {langMenu && (
                <div className="DhenkanalNavbarPage-lang-menu" onClick={(event) => event.stopPropagation()}>
                  <button type="button" onClick={() => handleLanguageChange("en")}>{t("English")}</button>
                  <button type="button" onClick={() => handleLanguageChange("hi")}>{t("Hindi")}</button>
                </div>
              )}
            </div>

          </div>
        </div>


          {/* LEFT – LOGO + TITLE */}
      </header>
    </>
  );
};

export default Dhealnavbar;
